export enum ActionTypes {
    PROJECT_SELECTED = 'PROJECT_SELECTED'

}



// WEBPACK FOOTER //
// ./src/sub-projects/tenant/types/action-types.ts